import React, { FC } from 'react'
import { Chip, ChipProps } from '@mui/material'

const EvtChip: FC<ChipProps> = ({ ...props }) => {
    return <Chip {...props} />
}

export default EvtChip
